import React, { useState, useCallback, useEffect, useRef } from "react";
import { Text } from "../";
import NextButton from "../NextButton";
import { IToastMessage } from "./types";
import {
  StyledToastMessageTextWrapper,
  StyledToastMessageCtasWrapper,
  StyledToastMessageProgress,
} from "./styled";

const ToastMessage: React.FC<IToastMessage> = ({
  message,
  countdown: countdownProp,
  positiveCtaText,
  negativeCtaText,
  onPositiveCta,
  onNegativeCta,
  closeToast,
}) => {
  const [countDown, setCountDown] = useState<number | undefined>(countdownProp);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const hasCtas = !!(positiveCtaText || negativeCtaText);

  const _onPositiveCta = useCallback(() => {
    onPositiveCta?.({ closeToast });
  }, [onPositiveCta, closeToast]);

  const _onNegativeCta = useCallback(() => {
    onNegativeCta?.();
    closeToast?.();
  }, [onNegativeCta, closeToast]);

  useEffect(() => {
    if (!countDown) {
      return;
    }
    if (countDown < 0) {
      closeToast?.();
      return;
    }
    let delay = 25;
    let interval = (intervalRef.current = setTimeout(() => {
      setCountDown((sec) => {
        if (!sec) {
          return sec;
        }
        return sec - delay / 1000;
      });
    }, delay));
    return () => clearTimeout(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countDown]);

  return (
    <>
      <StyledToastMessageTextWrapper>
        {countdownProp && (
          <StyledToastMessageProgress
            $prct={(1 - (countDown || 0) / countdownProp) * 100}
          >
            <span />
          </StyledToastMessageProgress>
        )}
        <Text isInline size="14px">
          {message}
        </Text>
      </StyledToastMessageTextWrapper>
      {hasCtas && (
        <StyledToastMessageCtasWrapper>
          {positiveCtaText && (
            <NextButton variant="blue" size="xs" onClick={_onPositiveCta}>
              {positiveCtaText}
            </NextButton>
          )}
          {negativeCtaText && (
            <NextButton variant="secondary" size="xs" onClick={_onNegativeCta}>
              {negativeCtaText}
            </NextButton>
          )}
        </StyledToastMessageCtasWrapper>
      )}
    </>
  );
};

export default ToastMessage;
